import React, { useEffect, useState } from 'react';
import '../../../../../App.css';
import MUIDataTable from 'mui-datatables';
import {makeStyles} from '@material-ui/core/styles';
import {Container, Typography, Select, MenuItem, TextField} from '@material-ui/core';
import SearchBar from '../../../../../components/shared/SearchBar';
import generateStyles from './style';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { deleteInvoice, getAllInvoices } from '../invoice.service';
import { Invoice, InvoiceItem } from '../invoice.model';
import { formatDate, getHeaderForPrint } from '../../../../../common/common.service';
import { Link } from 'react-router-dom';
import Loading from '../../../../../components/shared/Loading';
import { useConfirm } from 'material-ui-confirm';
import jsPDF from 'jspdf';
import { getUser } from '../../../../login/login.service';
import { getCustomerPromise } from '../../customers/customer.service';
const numberToWords = require('num-words');
const monthArr=["January","February","March","April",'May',"June","July","August","September","October", "November","December"]

const options: any = {
  selectableRows: 'none',
   setRowProps: (columns: any, value: any, tableMeta: any, updateValue: any) => {
    return {
      style: {boxShadow: '0px 3px 5px #00000029', borderRadius: 6}
    };
  }
};
function compare(a:any, b:any) {
  // Use toUpperCase() to ignore character casing
  const bandA = parseInt(a.invoiceNo);
  const bandB = parseInt(b.invoiceNo);

  let comparison = 0;
  if (bandA > bandB) {
    comparison = 1;
  } else if (bandA < bandB) {
    comparison = -1;
  }
  return comparison;
}


export default function InvoiceList(props: any): JSX.Element {
  const { filterYear} = props;
  const currentMonth = new Date().getMonth();
  const classes = generateStyles();
  const [ invoiceList, setInvoiceList ] = useState<any[]>([]);
  const [ invoices, setInvoices ] = useState<any[]>([]);
  const [rows, setRows] = useState<any[]>([]);
  const [ filterMonth, setFilterMonth ] = useState<number>(-1);
  const [ searchText, setSearchText ] = useState<string>('');
  let [loading, setLoading]   =   useState(false);
  const confirm = useConfirm();

  let mounted = true;

  const taxAmount = rows.reduce((acc, cur) => acc + cur.taxableAmount, 0);
  const taxValue = rows.reduce((acc, cur) => acc + cur.taxableValue, 0);
  const totalAmount = rows.reduce((acc, cur) => acc + cur.totalAmount, 0);

  const handleFilteMonthChange = (e: any) => {
    setFilterMonth(e.target.value);
  }


  // Trigger once the filter month is changed
  useEffect(() => {
    setLoading(true);
    var year = filterYear
    if(filterMonth>2){
      year = filterYear-1
    }
    console.log(year)
    const newRows = invoiceList.filter((row: any) => (filterMonth === 12 ? true : (new Date(row.date).getMonth() === filterMonth && new Date(row.date).getFullYear() === year)) && (row.companyName.toLowerCase().includes(searchText.toLowerCase().trim())));
    setRows(newRows);
    setLoading(false);
  },[filterMonth, filterYear]);

  const handleItemDelete = (id: string, index: number) => {
    confirm({
      title: 'Heads Up,',
      description: 'Are your sure? Want to delete this Invoice?',
      cancellationText: 'No',
      confirmationText: 'Yes, Delete it!',
      dialogProps: {
        open: true,
        maxWidth: 'xs'
      }
    })
    .then(() => {
      setLoading(true);
      deleteInvoice(id)
      .then(_ => {
        let newRows = [...rows]
        newRows.splice(index, 1);
        setRows(newRows);
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        console.log(err)
      });
    })
    .catch(() => console.log('Cancelled!'))
  }

  const preparePDFForInvoiceList = () => {
    setLoading(true);
    const user = getUser();
    const sortedRows=rows.sort(compare)
    const tableRows = sortedRows.map((row: any, index: number) => `
      <tr style="font-size: 6px;">
          <td>${index + 1}</td>
          <td>${row.companyName}</td>
          <td>${row.invoiceNo}</td>
          <td>${formatDate(row.date).split('-').reverse().join('-')}</td>
          <td>${row.taxableValue}</td>
          <td>${row.taxableAmount}</td>
          <td>${row.totalAmount}</td>
      </tr>
    `); 
    const invoiceList = `
    <main style="width: 425px; height: 610px;display: flex; flex-direction: column;">


      <hr />

      <div style="height:text-align: center;display: flex; flex-direction: column; justify-content: center; margin-bottom: 20px">
          <h3 style="text-align: center;margin: 0">Invoice Summary</h3>
       </div>

 

      <div style="margin-top: 20px; display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100% !important; padding: 0 8px">
      <div style="display:flex;flex-direction:row; width:100%">
        <div style="padding-top:60px;width:50%">${getHeaderForPrint({user})}</div>
          <div style="font-size: 6px; width: 50%; margin-bottom: 10px; display:flex; flex-direction: column;justify-content: center;">
          <div style="border-bottom:1px solid black; font-weight:700;font-size:10px;width:120px;margin-left:50px">
          Statement of Accounts
          </div>
          <h6 style="text-align:end;font-size:8px;margin: 0;padding:3px;padding-right:0px;border-bottom:1px solid black;width:120px;margin-left:50px">${filterMonth !== 12 ? `${monthArr[filterMonth]} to ${monthArr[filterMonth!==11?filterMonth+1:0]}`: `${monthArr[3]} to ${monthArr[2]}`}</h6> 
    
              <div >
                <p style="background-color:#F0F0F0;justify-content:start; width:170px;padding:5px;padding-bottom:7px">Account Summmary</p>
             
              </div>
              
              <div style="display:flex; justify-content:space-between; width:170px">
                  <p>Value</p>
                  <p>Rs. ${taxValue.toLocaleString('en-IN')}</p>
              </div>
              <div style="display:flex; justify-content:space-between; width:170px;border-bottom:1px solid black;">
                  <p>Tax Amount</p>
                  <p>Rs. ${taxAmount.toLocaleString('en-IN')}</p>
              </div>
              <div style="display:flex; justify-content:space-between;width:170px">
                  <p>Total Amount</p>
                  <p>Rs. ${totalAmount.toLocaleString('en-IN')}</p>
              </div>
          </div>
          </div>
          <table style="width: 100%;margin-bottom:30px">
              <tr style="font-size: 6px;background-color: rgb(82, 86, 89);padding:2px;color: white;padding-bottom:5px">
                  <td>S.No</td>
                  <td>Company Name</td>
                  <td>Invoice No.</td>
                  <td>Date</td>
                  <td>Taxable Value</td>
                  <td>Taxable Amount</td>
                  <td>Total Amount</td>
              </tr>

              ${tableRows.join('')} 
          </table>
      </div>
  </main>
    `;
    var doc = new jsPDF({
        orientation: 'p',
        unit: 'px',
        format: 'a4'
       });
    doc.html(invoiceList, {
        callback: function (doc) {
        // doc.save();
        doc.autoPrint();
        var oHiddFrame = document.createElement("iframe");
        oHiddFrame.style.position = "fixed";
        oHiddFrame.style.visibility = "hidden";
        oHiddFrame.src = doc.output("bloburl").toString();
        document.body.appendChild(oHiddFrame);
        oHiddFrame.onload = () => {
            if(oHiddFrame.contentWindow) {
                setLoading(false);
                oHiddFrame.contentWindow.focus();
            }
        };
        },
        x: 10,
        y: 10
    });
  }


  const preparePDF = async (id: string) => {
    console.log(id)
    console.log(invoices);
    setLoading(true);
    const currentInvoice = invoices.find((invoice: Invoice) => invoice.id == id );
    const customer = await getCustomerPromise(currentInvoice.customer.id)
    let total = 0;
    let cgst = 0;
    let sgst = 0;
  
    const invoiceItemTaxRows: any[] = [];
    let invoiceTaxTaxableValue = 0;
    let invoiceTaxTaxValue = 0  ;
    let invoiceTaxTotalTaxValue = 0  ;
    // const invoiceItemTaxRowsHSN: any = {};


    const invoiceItemRows = currentInvoice.items.map((invoiceItem: InvoiceItem, index: number) => {
      const gst = ((invoiceItem.amount * invoiceItem.tax)/100);
      cgst += (gst/2);
      sgst += (gst/2);
      total += invoiceItem.amount;

      invoiceTaxTaxableValue += invoiceItem.amount;
      invoiceTaxTaxValue += (gst/2);
      invoiceTaxTotalTaxValue += invoiceItem.amount + gst;

      invoiceItemTaxRows.push(
        `
        <tr>
          <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.5px solid #000; text-align: left">${invoiceItem.hsnCode}</td>
          <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.25px solid #000; text-align: right">${invoiceItem.amount}</td>
          <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.25px solid #000; text-align: right">${((invoiceItem.tax)/2).toFixed(1)}%</td>
          <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.25px solid #000; text-align: right">${gst/2}</td>
          <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.25px solid #000; text-align: right">${((invoiceItem.tax)/2).toFixed(1)}%</td>
          <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.25px solid #000; text-align: right">${gst/2}</td>
          <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.5px solid #000;border-right: 0.5px solid #000; text-align: right">${((gst/2) + (gst/2))}</td>
        <tr>
      `
      )

      // if(!invoiceItemTaxRowsHSN[invoiceItem.hsnCode]) {
      //   invoiceItemTaxRowsHSN[invoiceItem.hsnCode] = {
      //     amount: invoiceItem.amount,
      //     cgst: ((invoiceItem.amount * invoiceItem.tax)/200),
      //     sgst: ((invoiceItem.amount * invoiceItem.tax)/200),
      //     total: (invoiceItem.amount + cgst + sgst)
      //   }
      // } else {
      //   const currentHSNObj = invoiceItemTaxRowsHSN[invoiceItem.hsnCode];
      //   invoiceItemTaxRowsHSN[invoiceItem.hsnCode] = {
      //     amount: currentHSNObj.amount + invoiceItem.amount,
      //     cgst: currentHSNObj.cgst + ((invoiceItem.amount * invoiceItem.tax)/200),
      //     sgst: currentHSNObj.sgst + ((invoiceItem.amount * invoiceItem.tax)/200),
      //     total: (currentHSNObj.total + invoiceItem.amount + cgst + sgst)
      //   }
      // }

      return `
        <tr>
          <td style="text-align: center; border-left: 0.5px solid #000; font-size: 6px;">${index + 1}</td>
          <td style="text-align: left; border-left: 0.25px solid #000; font-size: 6px;">${invoiceItem.name}</td>
          <td style="text-align: center; border-left: 0.25px solid #000; font-size: 6px;">${invoiceItem.hsnCode}</td>
          <td style="text-align: center; border-left: 0.25px solid #000; font-size: 6px;">${invoiceItem.tax}</td>
          <td style="text-align: center; border-left: 0.25px solid #000; font-size: 6px;">${invoiceItem.quantity} ${invoiceItem.unit}</td>
          <td style="text-align: center; border-left: 0.25px solid #000; font-size: 6px;">${invoiceItem.rate}</td>
          <td style="text-align: center;  border-left: 0.25px solid #000; font-size: 6px;">${invoiceItem.unit}</td>
          <td style="text-align: center; border-right: 0.5px solid #000;border-left:0.5px solid #000; font-size: 6px;">${invoiceItem.amount}</td>
        </tr>
      `;
    })

    cgst = parseFloat(cgst.toFixed(2));
    sgst = parseFloat(sgst.toFixed(2));
    let grandTotal = parseFloat((total + cgst + sgst).toFixed(2));
    const user = getUser();
    console.log(user)
    const invoicePdf = `
        <main style="width: 425px; height: 610px;display: flex; flex-direction: column;">

            <div style="text-align: center;display: flex; flex-direction: column; justify-content: center; margin-bottom: 5px">
                <h3 style="text-align: center;margin: 0; margin: 0">Tax Invoice</h3>
                <h6 style="text-align: center;margin: 0">${filterYear-1}-${filterYear}</h6> 
            </div>
            ${getHeaderForPrint({user, invoice: currentInvoice, customer}, true)}

            <div style="display: flex; flex-direction: column; width: 100% !important; padding: 0">
                <table style="width: 100% !important; margin-top: 10px; padding: 0; border-collapse: collapse;">
                  <tr>
                    <td style="text-align: center; border-top: 0.25px solid #000; border-bottom: 0.25px solid #000; border-left: 0.5px solid #000; font-size: 6px;">S. No.</td>
                    <td style="text-align: center; border-top: 0.25px solid #000; border-bottom: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px;">Description of Goods</td>
                    <td style="text-align: center; border-top: 0.25px solid #000; border-bottom: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px;">HSN/SAC</td>
                    <td style="text-align: center; border-top: 0.25px solid #000; border-bottom: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px;">GST Rate</td>
                    <td style="text-align: center; border-top: 0.25px solid #000; border-bottom: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px;">Quantity</td>
                    <td style="text-align: center; border-top: 0.25px solid #000; border-bottom: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px;">Rate</td>
                    <td style="text-align: center; border-top: 0.25px solid #000; border-bottom: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px;">Unit</td>
                    <td style="text-align: center; border-top: 0.25px solid #000; border-bottom: 0.25px solid #000; border-right: 0.5px solid #000;border-left:0.5px solid #000;font-size: 6px; text-align: right">Amount</td>
                  </tr>

                  ${invoiceItemRows.join('')}

                  ${
                    new Array(5 - invoiceItemRows.length).fill(
                      `
                      <tr>
                        <td style="text-align: left; border-left: 0.5px solid #000; font-size: 6px;">&nbsp</td>
                        <td style="text-align: left; border-left: 0.25px solid #000; font-size: 6px;"></td>
                        <td style="text-align: center; border-left: 0.25px solid #000; font-size: 6px;"></td>
                        <td style="text-align: center; border-left: 0.25px solid #000; font-size: 6px;"></td>
                        <td style="text-align: right; border-left: 0.25px solid #000; font-size: 6px;"></td>
                        <td style="text-align: right; border-left: 0.25px solid #000; font-size: 6px;"></td>
                        <td style="text-align: left;  border-left: 0.25px solid #000; font-size: 6px;"></td>
                        <td style="text-align: righy; border-right: 0.5px solid #000;border-left:0.5px solid #000; font-size: 6px; text-align: right"></td>
                      </tr>
                    ` 
                    ).join('')
                  }
                  

                  <tr>
                    <td style="border-left: 0.5px solid #000; font-size: 6px;"></td>
                    <td style="border-left: 0.25px solid #000; font-size: 6px;"></td>
                    <td style="border-left: 0.25px solid #000; font-size: 6px;"></td>
                    <td style="border-left: 0.25px solid #000; font-size: 6px;"></td>
                    <td style="border-left: 0.25px solid #000; font-size: 6px;"></td>
                    <td style="border-left: 0.25px solid #000; font-size: 6px;"></td>
                    <td style="border-left: 0.25px solid #000; font-size: 6px;"></td>
                    <td style="border-right: 0.5px solid #000;border-left:0.5px solid #000; font-size: 6px; text-align: right">${total}</td>
                  </tr>

                  
                  ${cgst?<tr>
                    <td style={{borderTop: "0.25px solid #000", borderLeft: "0.5px solid #000", fontSize: "6px"}}></td>
                    <td style={{borderTop: "0.25px solid #000", borderLeft: "0.25px solid #000", fontSize: "6px"}}>CGST</td>
                    <td style={{borderTop: "0.25px solid #000", borderLeft: "0.25px solid #000", fontSize: "6px"}}></td>
                    <td style={{borderTop: "0.25px solid #000", borderLeft: "0.25px solid #000", fontSize: "6px"}}></td>
                    <td style={{borderTop: "0.25px solid #000", borderLeft: "0.25px solid #000", fontSize: "6px"}}></td>
                    <td style={{borderTop: "0.25px solid #000", borderLeft: "0.25px solid #000", fontSize: "6px"}}></td>
                    <td style={{borderTop: "0.25px solid #000", borderLeft: "0.25px solid #000", fontSize: "6px"}}></td>
                    <td style={{borderTop: "0.25px solid #000", borderLeft: "0.5px solid #000", fontSize: "6px", textAlign: 'right'}} >${cgst}</td>
                  </tr>:""}

              ${sgst?<tr>
                <td style={{borderTop: "0.25px solid #000", borderLeft: "0.5px solid #000", fontSize: "6px"}}></td>
                <td style={{borderTop: "0.25px solid #000", borderLeft: "0.25px solid #000", fontSize: "6px"}}>SGST</td>
                <td style={{borderTop: "0.25px solid #000", borderLeft: "0.25px solid #000", fontSize: "6px"}}></td>
                <td style={{borderTop: "0.25px solid #000", borderLeft: "0.25px solid #000", fontSize: "6px"}}></td>
                <td style={{borderTop: "0.25px solid #000", borderLeft: "0.25px solid #000", fontSize: "6px"}}></td>
                <td style={{borderTop: "0.25px solid #000", borderLeft: "0.25px solid #000", fontSize: "6px"}}></td>
                <td style={{borderTop: "0.25px solid #000", borderLeft: "0.25px solid #000", fontSize: "6px"}}></td>
                <td style={{borderTop: "0.25px solid #000", borderLeft: "0.5px solid #000", fontSize: "6px", textAlign: 'right'}} >${sgst}</td>
              </tr>:""}

                  <tr>
                    <td style="border-top: 0.25px solid #000; border-left: 0.5px solid #000; font-size: 6px;"></td>
                    <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px;">Total</td>
                    <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px;"></td>
                    <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px;"></td>
                    <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px;"></td>
                    <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px;"></td>
                    <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px;"></td>
                    <td style="border-top: 0.25px solid #000; border-right: 0.5px solid #000;border-left:0.5px solid #000; font-size: 6px; text-align: right">${grandTotal}</td>
                  </tr>

                  <tr>
                    <td colspan="8" style="border-top: 0.25px solid #000; border-left: 0.5px solid #000;border-right: 0.5px solid #000; font-size: 6px;">
                      Amount Chargable (in words) <br />
                      Rupee ${numberToWords(grandTotal)} only
                    </td>
                  </tr>
                </table>

                <table style="width: 100%; margin: 0; border-collapse: collapse;">
                  <tr style="display:${cgst||sgst?"":"none"}">
                    <td style="border-top: 0.25px solid #000; border-left: 0.5px solid #000;border-bottom: none; font-size: 6px; text-align: center">HSN/SAC</td>
                    <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000;border-bottom: none; font-size: 6px; text-align: center">Taxable</td>
                    <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px; text-align: center" colspan="2">Central Tax</td>
                    <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px; text-align: center" colspan="2">State Tax</td>
                    <td style="border-top: 0.25px solid #000;border-left: 0.25px solid #000; border-right: 0.5px solid #000;border-bottom: none; font-size: 6px; text-align: center">Total</td>
                  </tr>

                <tr style="display:${cgst||sgst?"":"none"}">
                  <td style="border-left: 0.5px solid #000;"></td>
                  <td style="border-left: 0.25px solid #000; font-size: 6px; text-align: center">Value</td>
                  <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px; text-align: center">Rate</td>
                  <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px; text-align: center">Amount</td>
                  <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px; text-align: center">Rate</td>
                  <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px; text-align: center">Amount</td>
                  <td style="border-left: 0.25px solid #000; border-right: 0.5px solid #000; font-size: 6px; text-align: center">Tax Amount</td>
                </tr>

                ${cgst||sgst?invoiceItemTaxRows.join(''):""}

                ${
                  new Array(5 - invoiceItemTaxRows.length).fill(
                    `
                    <tr style="display:${cgst||sgst?"":"none"}">
                      <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.5px solid #000; text-align: left">&nbsp;</td>
                      <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.25px solid #000; text-align: right"></td>
                      <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.25px solid #000; text-align: right"></td>
                      <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.25px solid #000; text-align: right"></td>
                      <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.25px solid #000; text-align: right"></td>
                      <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.25px solid #000; text-align: right"></td>
                      <td style="font-size: 6px; border-top: 0.25px solid #000; border-left: 0.25px solid #000;border-right: 0.5px solid #000; text-align: right"></td>
                    <tr>
                  `
                  ).join('')
                }

                <tr style="display:${cgst||sgst?"":"none"}">
                  <td style="border-top: 0.25px solid #000; border-left: 0.5px solid #000; font-size: 6px;text-align: right">Total</td>
                  <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px; text-align: right">${invoiceTaxTaxableValue}</td>
                  <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px; text-align: center"></td>
                  <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px; text-align: right">${invoiceTaxTaxValue}</td>
                  <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px; text-align: center"></td>
                  <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; font-size: 6px; text-align: right">${invoiceTaxTaxValue}</td>
                  <td style="border-top: 0.25px solid #000; border-left: 0.25px solid #000; border-right: 0.5px solid #000; font-size: 6px; text-align: right">${cgst + sgst}</td>
                </tr>

                  <tr style="display:${cgst||sgst?"":"none"}">
                    <td colspan="7" style="border-top: 0.25px solid #000; border-left: 0.5px solid #000;border-right: 0.5px solid #000; font-size: 6px;">
                      Tax Amount (in words) <br />
                      Rupee ${numberToWords(cgst + sgst)} only
                    </td>
                  </tr>

                  <tr>
                    <td style="padding: 0 0 5px 5px; font-size: 6px; border-top: 0.25px solid #000; border-bottom: 0.5px solid #000; border-left: 0.5px solid #000;" colspan="4">
                      Company's PAN: ${user.companyPAN}<br />
                      Account Name: ${user.bankAccountName}<br />
                      Account Number: ${user.bankAccountNumber} <br />
                      IFSC Code: ${user.bankIFSC}
                    </td>
                    <td style="font-size: 6px; border-top: 0.25px solid #000;border-bottom: 0.5px solid #000; border-right: 0.5px solid #000; border-left: 0.25px solid #000; text-align: center" colspan="4">
                      <div style="padding-top: 5px">for ${user.name}</div>
                      <br/>
                      <br />
                      <br />
                      <br />
                      <div style="padding-bottom: 5px">Authorised Signatory</div>
                    </td>
                  </tr>
                </table>
            </div>
            <p style="font-size: 6px; text-align: center">This is a Computer Generated Invoice</p>
        </main>
    `;

    var doc = new jsPDF({
        orientation: 'p',
        unit: 'px',
        format: 'a4'
      });
    doc.html(invoicePdf, {
        callback: function (doc) {
        // doc.save();
        doc.autoPrint();
        var oHiddFrame = document.createElement("iframe");
        oHiddFrame.style.position = "fixed";
        oHiddFrame.style.visibility = "hidden";
        oHiddFrame.src = doc.output("bloburl").toString();
        document.body.appendChild(oHiddFrame);
        oHiddFrame.onload = () => {
            if(oHiddFrame.contentWindow) {
                setLoading(false);
                oHiddFrame.contentWindow.focus();
            }
        };
        },
        x: 10,
        y: 10
    });
    console.log(currentInvoice);
    
  }

  const columns: any = [
    {
      name:"sno",
      label: 'S.NO',
      options: {
        sort: false,
        setCellHeaderProps: (value: any) => ({ style: { borderBottomLeftRadius: 6, borderTopLeftRadius: 6, display: 'flex', height: '52.8px', justifyContent: 'center', alignItems: 'center' } }),
        setCellProps: (cellValue: any, rowIndex: any, columnIndex: any) => ({style: {borderBottomLeftRadius: 6, borderTopLeftRadius: 6}}),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <div style={{textAlign: 'center', color:"#112B42"}}>{tableMeta.rowIndex + 1}</div>
          );
        }
      }
    },
    {
      name:"companyName",
      label: 'Company Name',
      options: {
        sortThirdClickReset: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          // console.log(rows)
          return (
            <div style={{color:"#112B42"}}>{value}</div>
          );
        }
      }
    }, 
    {
      name: 'invoiceNo',
      label:"Invoice No",
      options: {
        sortThirdClickReset: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          // console.log(rows)
          return (
            <div style={{color:"#112B42"}}>{value}</div>
          );
        }
      }
    },
    {
      name: "date",
      label:"Date",
      options: {
        sortThirdClickReset: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          // console.log(rows)
          return (
            <div style={{color:"#112B42"}}>{value.split('-').reverse().join('-')}</div>
          );
        }
      }
    }, 
    {
      name: "taxableValue",
      label:"Taxable Value",
      options: {
        sortThirdClickReset: true,
        setCellHeaderProps: (value: any) => ({className: makeStyles({'rateHeader': {'& > span': {justifyContent: 'flex-end'}}})().rateHeader}),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <div className="txt-al-r" style={{textAlign:"left", marginLeft:"35px", color:"#112B42"}}> ₹ {value.toLocaleString('en-IN')}</div>
          );
        }
      }
    },
    {
      name: "taxableAmount",
      label:"Taxable Amount",
      options: {
        sortThirdClickReset: true,
        setCellHeaderProps: (value: any) => ({className: makeStyles({'rateHeader': {'& > span': {justifyContent: 'flex-end'}}})().rateHeader}),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <div className="txt-al-r" style={{textAlign:"left", marginLeft:"35px", color:"#112B42"}}> ₹ {value.toLocaleString('en-IN')}</div>
          );
        }
      }
    },
    {
      name: "totalAmount",
      label:"Total Amount",
      options: {
        sortThirdClickReset: true,
        setCellHeaderProps: (value: any) => ({className: makeStyles({'rateHeader': {'& > span': {justifyContent: 'flex-end'}}})().rateHeader}),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <div className="txt-al-r" style={{color:"#112B42"}}> ₹ {value.toLocaleString('en-IN')}</div>
          );
        }
      }
    },
    {
      name: 'action',
      label: "Action",
      options: {
        filter: false,
        sort: false,
        empty: true,
        setCellHeaderProps: (value: any) => ({ style: { borderBottomRightRadius: 6, borderTopRightRadius: 6, display: 'table-cell', textAlign: 'right', paddingRight: 35 } }),
        setCellProps: (cellValue: any, rowIndex: any, columnIndex: any) => ({style: {borderBottomRightRadius: 6, borderTopRightRadius: 6}}),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <div className="txt-al-r" style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
              <img src="/img/print.png" onClick={() => preparePDF(value)} alt="print icon" style={{cursor: 'pointer', width:"20px", marginLeft:"10px"}}/>
              <Link to={`/dashboard/invoices/${value}`}><img src="/img/editpencil.png" alt="edit icon" style={{cursor: 'pointer', width:"17px", marginLeft:"13px"}}/></Link>
              {/* <Link to={`/dashboard/invoices/${value}`}><VisibilityIcon style={{display: 'flex', alignItems: 'center', cursor: 'pointer', marginLeft:"13px", marginRight:"10px"}} /></Link> */}
              <img src="/img/delete.png" alt="delete icon" onClick={() => handleItemDelete(value, tableMeta.rowIndex)} style={{cursor: 'pointer', width:"13px", marginLeft:"13px", marginRight:"10px"}}/>
            </div>
          );
        }
      }
    },
  ];

  const mapInvoiceToRow = (invoice: Invoice, index: number) => {
    return {
      companyName: invoice.customer.companyName,
      invoiceNo: parseInt(invoice.number),
      gstin: invoice.gstin,
      date: formatDate(invoice.date),
      taxableValue: invoice.subTotal,
      taxableAmount: invoice.sgst + invoice.cgst,
      totalAmount: invoice.total,
      action: invoice.id
    };
  }

  const fetchAndSetInvoiceList = async () => {
    setLoading(true);
    getAllInvoices((invoices: Invoice[]) => {
      if(mounted) {
        setInvoices(invoices);
        console.log(invoices);
        const invoiceRows = invoices.map(mapInvoiceToRow);
        console.log(invoiceRows);
        // setRows(invoiceRows);
        setInvoiceList(invoiceRows);
        setFilterMonth(currentMonth);
        setLoading(false);
      }
    });
  }

  // componentDidMount
  useEffect(()=> {
    fetchAndSetInvoiceList();

    return () => {
      mounted = false;
    }
  },[]);

  const handleSearch = (text: string) => {
    console.log('Search text trigger => ', searchText, rows);
      var year = filterYear
    if(filterMonth>2){
      year = filterYear-1
    }
    const invoices = invoiceList.filter((invoice: any) => (filterMonth === 12 ? true : (new Date(invoice.date).getMonth() === filterMonth && new Date(invoice.date).getFullYear() ===year) ) && (invoice.companyName.toLowerCase().includes(text.toLowerCase().trim())))
    setRows(invoices);
    setSearchText(text)
  }

  return (
    <>
      <Container maxWidth="lg">
        <header className={classes.header}>
          <span style={{color:"#112B42"}}>Invoice List</span>
          {/* <span style={{display: 'flex', alignItems: 'center'}}>
            <SearchBar searchText="Search by customer..." addBtnLink='/dashboard/invoices/new' value={searchText} size="lg" searchFunction={handleSearch}/>
            <Select className={classes.drop} value={filterMonth} onChange={handleFilteMonthChange} disableUnderline IconComponent={(props) => <ExpandMoreIcon {...props}/>}>
                <MenuItem value={-1}>Select month</MenuItem>
                <MenuItem value={0}>January</MenuItem>
                <MenuItem value={1}>February</MenuItem>
                <MenuItem value={2}>March</MenuItem>
                <MenuItem value={3}>April</MenuItem>
                <MenuItem value={4}>May</MenuItem>
                <MenuItem value={5}>June</MenuItem>
                <MenuItem value={6}>July</MenuItem>
                <MenuItem value={7}>August</MenuItem>
                <MenuItem value={8}>September</MenuItem>
                <MenuItem value={9}>October</MenuItem>
                <MenuItem value={10}>November</MenuItem>
                <MenuItem value={11}>December</MenuItem>
                <MenuItem value={12}>All Months</MenuItem>
            </Select>

            <TextField
              style={{color: '#96A9C3 !important', backgroundColor: '#F4F4F6', width: 150, padding: '0 10px', borderRadius: 5, marginRight: 25,}}
              InputProps={{disableUnderline: true}}
              // labelId="demo-simple-select-label"
              // label="Age"
              id="demo-simple-select"
              // onChange={handleChange}
              select
              SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
              value={filterYear}
              onChange={handleFilterYearChange}
          >
              <MenuItem value={-1}>Select year</MenuItem>
              <MenuItem value={2020}>2020</MenuItem>
              <MenuItem value={2021}>2021</MenuItem>
              <MenuItem value={2022}>2022</MenuItem>
              <MenuItem value={2023}>2023</MenuItem>
              <MenuItem value={2024}>2024</MenuItem>
              <MenuItem value={2025}>2025</MenuItem>
          </TextField>

          </span> */}
        </header>
      </Container>
      <hr style={{height: 1, backgroundColor: '#ced2de', border: 'none'}}></hr>
      <Container style={{ fontSize:"13px"}} maxWidth="lg" className="mt-20">
        <div className={classes.boxtotalinvoice}>
          {/* <div className={classes.totalamount}>Total Invoice
            <Typography style={{fontWeight:'bold', color:'#0079E4'}}>{ totalInvoices }</Typography>
          </div> */}
          <div className={classes.totalamount}>Tax Amount
            <Typography style={{fontWeight:'bold', color:'#0079E4', textAlign:'center'}}>₹ { parseFloat(taxAmount.toFixed(2)).toLocaleString('en-IN')}</Typography>
          </div>
          <div className={classes.totalamount}>Total Amount
            <Typography style={{fontWeight:'bold', color:'#0079E4', textAlign:'right'}}>₹ { parseFloat(totalAmount.toFixed(2)).toLocaleString('en-IN') }</Typography>
          </div>

          <span style={{display: 'flex', alignItems: 'center' }}>
            <SearchBar searchText="Search by customer..." styles={{backgroundColor: '#FFFFFF' }} addBtnLink='/dashboard/invoices/new' value={searchText} size="lg" searchFunction={handleSearch} />
            <Select className={classes.drop} style={{marginLeft: 30}} value={filterMonth} onChange={handleFilteMonthChange} disableUnderline IconComponent={(props) => <ExpandMoreIcon {...props}/>}>
                <MenuItem value={-1}>Select month</MenuItem>
                <MenuItem value={3}>April</MenuItem>
                <MenuItem value={4}>May</MenuItem>
                <MenuItem value={5}>June</MenuItem>
                <MenuItem value={6}>July</MenuItem>
                <MenuItem value={7}>August</MenuItem>
                <MenuItem value={8}>September</MenuItem>
                <MenuItem value={9}>October</MenuItem>
                <MenuItem value={10}>November</MenuItem>
                <MenuItem value={11}>December</MenuItem> 
                <MenuItem value={0}>January</MenuItem>
                <MenuItem value={1}>February</MenuItem>
                <MenuItem value={2}>March</MenuItem>
                <MenuItem value={12}>All Months</MenuItem>
            </Select>

           {/* <TextField
              style={{width: 100, padding: '0 10px', borderRadius: 5}}
              className={classes.drop}
              InputProps={{disableUnderline: true}}
              // labelId="demo-simple-select-label"
              // label="Age"
              id="demo-simple-select"
              // onChange={handleChange}
              select
              SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
              value={filterYear}
              onChange={handleFilterYearChange}
          >
              <MenuItem value={-1}>Select year</MenuItem>
              <MenuItem value={2020}>2020</MenuItem>
              <MenuItem value={2021}>2021</MenuItem>
              <MenuItem value={2022}>2022</MenuItem>
              <MenuItem value={2023}>2023</MenuItem>
              <MenuItem value={2024}>2024</MenuItem>
              <MenuItem value={2025}>2025</MenuItem>
           </TextField>*/}

          <span onClick={
            preparePDFForInvoiceList} style={{ display: 'flex', alignItems: 'center', marginLeft: 40}} className={`cursor-pointer`}>
              <img src="/img/pdf1.png" alt="pencil icon" style={{marginRight:"7px", width:"16px", color:"red"}}/>
              Pdf
          </span>
          </span>
        </div>
          <MUIDataTable title={"ACME Employee list"}data={rows} columns={columns} options={options} />
      </Container>
      <Loading loading={loading} text="Loading..."/>
    </>
  );
}
